import { defineComponent as r, openBlock as l, createBlock as c, unref as i, mergeProps as a, withCtx as p, createElementVNode as n } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconLocationPinOutlined",
  __name: "IconLocationPinOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (u, e) => (l(), c(i(d), a(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        n("path", { d: "M10.763 8.861a1.75 1.75 0 1 1 2.474 2.475 1.75 1.75 0 0 1-2.474-2.475" }, null, -1),
        n("path", {
          "fill-rule": "evenodd",
          d: "M12 2.348c-4.341 0-7.75 3.732-7.75 7.95 0 1.033.387 2.152.922 3.222.541 1.084 1.27 2.188 2.029 3.21 1.52 2.046 3.211 3.827 3.923 4.552a1.223 1.223 0 0 0 1.752 0c.712-.725 2.404-2.506 3.923-4.552.76-1.022 1.488-2.126 2.029-3.21.535-1.07.922-2.189.922-3.222 0-4.218-3.409-7.95-7.75-7.95m-6.25 7.95c0-3.453 2.8-6.45 6.25-6.45s6.25 2.997 6.25 6.45c0 .69-.27 1.562-.764 2.552-.488.976-1.161 2.003-1.891 2.986-1.337 1.8-2.823 3.398-3.595 4.196-.772-.798-2.258-2.396-3.595-4.196-.73-.983-1.403-2.01-1.891-2.986-.495-.99-.764-1.861-.764-2.552",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
